import React, {useState} from "react";
import "./ExperienceCard.scss";

export default function ExperienceCard({cardInfo, isDark, index = 0}) {
  const [imgError, setImgError] = useState(false);
  const [expanded, setExpanded] = useState(false);

  const bullets = cardInfo.descBullets || [];
  const visibleBullets = expanded ? bullets : bullets.slice(0, 3);
  const hasMore = bullets.length > 3;

  return (
    <div
      className={isDark ? "experience-card-dark" : "experience-card"}
      style={{"--card-i": index}}
    >
      <div className="experience-banner">
        <span className="experience-card-index" aria-hidden="true">
          {String(index + 1).padStart(2, "0")}
        </span>
        <div className="experience-div-company">
          <h5 className="experience-text-company">{cardInfo.company}</h5>
        </div>
      </div>

      <div className="experience-card-top">
        {!imgError && cardInfo.companylogo && (
          <img
            className="experience-roundedimg"
            src={
              typeof cardInfo.companylogo === "string"
                ? cardInfo.companylogo
                : cardInfo.companylogo.default || cardInfo.companylogo
            }
            alt={cardInfo.company}
            onError={() => setImgError(true)}
          />
        )}
        <div className="experience-meta">
          <h5 className="experience-text-role">{cardInfo.role}</h5>
          <h5 className="experience-text-date">{cardInfo.date}</h5>
        </div>
      </div>

      <div className="experience-text-details">
        <p className="subTitle experience-text-desc">{cardInfo.desc}</p>
        <ul>
          {visibleBullets.map((item, i) => (
            <li
              key={i}
              className="subTitle experience-bullet"
              style={{"--b": i}}
            >
              {item}
            </li>
          ))}
        </ul>
        {hasMore && (
          <button
            type="button"
            className="experience-expand"
            onClick={() => setExpanded(v => !v)}
          >
            {expanded ? "Show less" : `+${bullets.length - 3} more`}
          </button>
        )}
      </div>
    </div>
  );
}
